//3rd Party Components
import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import moment from 'moment';
import axios from 'axios';
import UAParser from 'ua-parser-js';

//Components
import Heading from '../components/CASA/Heading';
import CasaModal from '../components/CASA/CasaModal';
import MetaTags from 'react-meta-tags';
import AUbutton from '@gov.au/buttons';
import SortedTable from '../components/Portal/SortedTable';
import { getDownloadRecAccredGoogleDetails, FETCH_DOWNLOADRECACCREDGOOGLE_SUCCESS } from '../PortalStore/Actions/DownloadRecAccredGoogleActions';
import { getDownloadRecAccredAppleDetails, FETCH_DOWNLOADRECACCREDAPPLE_SUCCESS } from '../PortalStore/Actions/DownloadRecAccredAppleActions';
import CASASpinner from '../components/Portal/CASASpinner';
import { getLicencesIndividual, FETCH_LICENCESINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/LicencesIndividualActions';
import { iOSversion } from '../components/Portal/Utilities';
import SharePointDownload from '../components/Portal/SharePointDownload';

//Actions
import { getExpirySelector, getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { setInnerHTML } from '../components/Portal/Utilities';

export const ShowRecAccredPage = () => {
    const [modalActiveGoogle, setModalActiveGoogle] = useState(false);
    const [modalActiveApple, setModalActiveApple] = useState(false);
    const [showSpinnerFlag, setShowSpinnerFlag] = useState(false);
    const [googleDownloadDone, setGoogleDownloadDone] = useState(false);
    const [appleDownloadDone, setAppleDownloadDone] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [iphone, setIphone] = useState(false);
    const [android, setAndroid] = useState(false);
    const [allowDownload, setAllowDownload] = useState(false);

    const dispatch = useDispatch();
    let googleSnippet = useSelector(state => getSnippetSelector(state, 'CASA - Download Google Accreditation'));
    let appleSnippet = useSelector(state => getSnippetSelector(state, 'CASA - Download Apple Accreditation'));

    let daysLic = useSelector(state => getExpirySelector(state, 'Portal - Licence expiry warning period'));

    const user = useSelector(state => state.userdetails.items?.value[0]);
    const B2CSettings = useSelector(state => state.B2CSettings.items);
    const googleUrl = useSelector(state => state.DownloadReplGoogle.items);
    const appleUrl = useSelector(state => state.DownloadReplApple.items);
    let licencesIndividual = useSelector(state => state.licencesIndividual);

    useEffect(() => {

        dispatch(addPageAlert({ level: '', title: '', message: '' }));

        let parser = new UAParser();
        setAndroid(parser.getOS().name === 'Android');
        setIphone(parser.getDevice().model === 'iPhone' && parseFloat(parser.getOS().version) >= 8.0);

        const webappurl = B2CSettings.webappurlPortalApi;
        const accessToken = B2CSettings.accesstokenPortal;

        axios.all([
            dispatch(getLicencesIndividual(webappurl, accessToken))
        ])
            .then(axios.spread((licsres) => {
                if (licsres.type !== FETCH_LICENCESINDIVIDUAL_SUCCESS
                ) {

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: SCAL.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(() => {
                dispatch(addPageAlert({ level: "error", title: "System error SCAL.2" }));
            })
            .finally(() => {
                setPageLoaded(true);
            });
    }, []);

    useEffect(() => {
        if (googleDownloadDone) {
            window.location.href = googleUrl.saveGooglePassUri;
        }
    }, [googleDownloadDone]);

    useEffect(() => {
        if (appleDownloadDone) {
            let reader = new FileReader();
            let blob = new Blob([appleUrl], { type: 'application/vnd.apple.pkpass' });

            reader.onloadend = function () {
                reader.fileName = 'Rec_CASA_Accred.pkpass';
                window.location.href = reader.result;
            };

            reader.readAsDataURL(blob);
        }

    }, [appleDownloadDone]);

    const toggleModalGoogle = () => setModalActiveGoogle(!modalActiveGoogle);

    const toggleModalApple = () => setModalActiveApple(!modalActiveApple);

    const onDigLicGoogleClick = () => setModalActiveGoogle(true);

    const onDigLicAppleClick = () => setModalActiveApple(true);

    const getGoogleLicence = () => {
        setModalActiveGoogle(false);
        setShowSpinnerFlag(true);

        const webappurl = B2CSettings.DigitalLicenceAPIUrl;

        axios.all([
            dispatch(getDownloadRecAccredGoogleDetails(webappurl, B2CSettings.accesstokenPortal, user.casa_arn))
        ])
            .then(axios.spread((drres) => {
                setShowSpinnerFlag(false);
                if (drres.type === FETCH_DOWNLOADRECACCREDGOOGLE_SUCCESS) {
                    setGoogleDownloadDone(true);
                }
                else {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: DRGL.1)'
                    }));
                }
            }))
            .catch(function () {
                setShowSpinnerFlag(false);
                dispatch(addPageAlert({
                    level: 'error',
                    title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                    message: 'Details: System error (Code: DRGL.2)'
                }));
            });
    };

    const getAppleLicence = () => {
        setModalActiveApple(false);
        setShowSpinnerFlag(true);

        const webappurl = B2CSettings.DigitalLicenceAPIUrl;

        axios.all([
            dispatch(getDownloadRecAccredAppleDetails(webappurl, B2CSettings.accesstokenPortal, user.casa_arn))
        ])
            .then(axios.spread((drres) => {
                setShowSpinnerFlag(false);
                if (drres.type === FETCH_DOWNLOADRECACCREDAPPLE_SUCCESS) {
                    setAppleDownloadDone(true);
                }
                else {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: DRAL.1)'
                    }));
                }
            }))
            .catch(function () {
                setShowSpinnerFlag(false);
                dispatch(addPageAlert({
                    level: 'error',
                    title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                    message: 'Details: System error (Code: DRAL.2)'
                }));
            });

    };

    const items = [
        {
            text: 'myCASA',
            link: '/dashind'
        },
        {
            text: 'Drone licences and accreditation'
        }
    ];
    let showItems = true;

    let accredsArr = [];
    let accredsCols = [
        {
            'label': 'Category',
            'property': 'category',
            'visible': true,
            'command': null,
            'commandLink': null,
            'type': 'string',
            'width': '33%'
        },

        {
            'label': 'Issue Date',
            'property': 'issueddate',
            'visible': true,
            'command': null,
            'commandLink': null,
            'hasMsg': null,
            'hasMsglevel': null,
            'type': 'date',
            'width': '25%'
        },
        {
            'label': 'Expiry Date',
            'property': 'expirydate',
            'visible': true,
            'command': null,
            'commandLink': null,
            "hasMsg": "msg",
            "hasMsglevel": "msglevel",
            'type': 'date',
            'width': '25%'
        },
        {
            'label': 'Status',
            'property': 'status',
            'visible': true,
            'command': null,
            'commandLink': null,
            'type': 'string',
            'width': '25%'
        }
    ];

    let caption = '';
    let sort = 'category';
    let today = moment().startOf('day');

    let expiryLic = moment().startOf('day').add(daysLic, 'days').subtract(1, 'days');

    for (let l = 0; l < licencesIndividual.items?.value?.length; l++) {
        let accred = {
            'issueddate': licencesIndividual.items?.value[l]['casa_origindate'] === null ? moment() : moment(licencesIndividual.items?.value[l]['casa_origindate'], 'YYYY-MM-DD').format('DD MMM YYYY'),
            'expirydate': licencesIndividual.items?.value[l]['casa_validuntil'] === null ? moment() : moment(licencesIndividual.items?.value[l]['casa_validuntil'], 'YYYY-MM-DD').format('DD MMM YYYY')
        };

        // check licences expiring for this individual
        var activeto = licencesIndividual.items?.value[l]['casa_validuntil'] === null ? moment() : moment(licencesIndividual.items?.value[l]['casa_validuntil'], 'YYYY-MM-DD');
        if (activeto.isValid() && expiryLic.isValid() && expiryLic > activeto && activeto >= today) {
            accred.msg = 'Expiring soon';
            accred.msglevel = 'warning';
        }

        accred.category = 'Recreational';
        accred.status = licencesIndividual.items?.value[l]['casa_eapstatus'];

        accredsArr.push(accred);
    }

    let badge = '';
    let downloadSPSize = 0;

    if (licencesIndividual.items?.value && licencesIndividual.items?.value[0].casa_eapstatus !== 'Active') {
        //show badge
        badge = { 'message': 'Suspended', 'level': 'error' };
    }

    if (licencesIndividual.items?.value && licencesIndividual.items?.value[0].casa_licenceurlfilesize !== null) {
        downloadSPSize = Math.round(licencesIndividual.items?.value[0].casa_licenceurlfilesize / 1024);
    }

    const showTable = () => (
        <SortedTable
            data={accredsArr}
            cols={accredsCols}
            caption={caption}
            sortby={sort}
            
        />
    );

    const showSpinner = () => {
        if (showSpinnerFlag) {
            return (<CASASpinner message='Working. Please wait.....' />);
        }
    };

    const downloadSP = () => {
        setAllowDownload(true);
    };

    const createDownload = () => {
        if (allowDownload) {
            let ios = iOSversion();
            let entity = 'casa_licence';
            let id = licencesIndividual.items?.value[0].casa_licenceid;
            let file = '';
            return (
                <SharePointDownload entity={entity} file={file} id={id} ios={ios} load={setAllowDownload} />
            )
        }
        else {
            return null;
        }
    };

    const upgradeButton = () => {
        var link = '/forms/drone-accreditation/commercial';
        
        return (
            <div>
                <a className='au-btn au-btn--secondary' href={link}>
                    Upgrade to commercial accreditation
                </a>
                <br/>
                <br/>
            </div>
        )
    }

    return (
        <Fragment>
            <div style={{ minHeight: '800px' }}>
                <MetaTags title='Drone accreditation'></MetaTags>

                <Heading
                    text='Drone accreditation'
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={false}
                    badge={badge}
                />

                <br />

                <CasaModal
                    heading='Digital accreditation'
                    toggle={toggleModalGoogle}
                    active={modalActiveGoogle}
                    scrollable={true}
                    action={getGoogleLicence}
                    image='/forms/images/enAU_add_to_google_wallet_wallet-button.svg'
                    imageText='Save to Google Wallet'
                    cancelLabel='Close'>
                    <Fragment >
                        <div dangerouslySetInnerHTML={setInnerHTML(googleSnippet)} />
                    </Fragment>
                </CasaModal>

                <CasaModal
                    heading='Digital accreditation'
                    toggle={toggleModalApple}
                    active={modalActiveApple}
                    scrollable={true}
                    action={getAppleLicence}
                    image='/forms/images/Add_to_Apple_Wallet_rgb_US-UK.svg'
                    imageText='Add to Apple Wallet'
                    cancelLabel='Close'>
                    <Fragment >
                        <div dangerouslySetInnerHTML={setInnerHTML(appleSnippet)} />
                    </Fragment>
                </CasaModal>

                {showSpinner()}

                <br />

                {android ? <AUbutton as='secondary' onClick={onDigLicGoogleClick}>Download digital accreditation for Google Wallet</AUbutton> : null}

                {iphone ? <AUbutton as='secondary' onClick={onDigLicAppleClick}>Download digital accreditation for Apple Wallet</AUbutton> : null}

                {downloadSPSize > 0 ?
                    <span
                        id="regdocs"
                        className="download-icon"
                        style={{ float: 'right' }}
                        align='right'>

                        <button style={{ backgroundColor: 'white', borderWidth: 0, paddingRight: 0 }} className="ismall i i-PDF" onClick={downloadSP} />

                        <button onClick={downloadSP} className="btn-link">
                            Download registration certificate (<abbr title='Portable Document Format'>PDF</abbr> {downloadSPSize}KB)
                        </button>

                        <br />

                        <div
                            id="msg-popup"
                            style={{ float: 'right' }}
                            align='right'>
                            You may need to enable popups in your browser to download your certificate
                        </div>

                        {createDownload()}

                        <br />

                    </span>
                    : null
                }

                {showTable()}

                {upgradeButton()}

            </div>
        </Fragment>
    );

};